<template>
  <div class="photo-wall-item">
    <ul class="photo-wall-item-img" :style="style">
      <li v-for="(slide,i) in playSlides" :key="i" :style="`background-image: url(${require('@/assets/' + slide.image)});`">
        <div class="photo-wall-item-title">{{slide.title}}</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PhotoWallItem',
  props: {
    photos: {
      type: Array,
      default: []
    },
  },
  data() {
    return {
      slides: [],
      current: 0,
      interval: 0,
      playSlides: []
    }
  },
  computed: {
    style() {
      switch (this.current % 2) {
        case 0:
          return { left: "0" }
        case 1:
          return { left: "-100%" }
      }
    }
  },
  methods: {
    play() {
      this.current++;
      if (this.current >= this.slides.length) {
        this.current = 0
      }
      this.playSlides[this.current % 2] = this.slides[this.current]
    }
  },
  created() {
    this.slides = [...this.photos, ...this.photos]

    this.playSlides[0] = this.slides[0]
    this.playSlides[1] = this.slides[1]
  }
}
</script>

<style lang="scss" scoped>
.photo-wall-item {
  overflow: hidden;
  position: relative;

  .photo-wall-item-img {
    list-style: none;
    position: absolute;
    width: 200%;
    height: 100%;
    margin: 0;
    padding: 0;
    transition: left 800ms;

    li {
      float: left;
      width: 50%;
      height: 100%;
      background: center / cover no-repeat;

      .photo-wall-item-title {
        background: rgba(0,0,0,0.5);
        height: 100%;
        width: 100%;
        text-align: center;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: 300ms;
        opacity: 0;
      }

      &:hover {
        .photo-wall-item-title {
          opacity: 1;

        }
      }
    }
  }
}

</style>
